<template>
  <div id="printReport">
    <div class="row">
      <div class="col-sm-2">
        <img src="@/assets/template/images/logo.png" alt="Consyst" style="height: 60px" />
      </div>
      <div class="col-sm-8">
        <h3 class="text-center">{{ title }}</h3>
        <h5 class="text-center">{{ sub_title }}</h5>
        <!-- <h5 class="text-center">Emitido em {{ new Date() | moment('DD/MM/YYYY') }} às {{ new Date() | moment('H[:]mm[h]')}}</h5> -->
      </div>
      <div class="col-sm-2"></div>
    </div>
   
    <template v-if="report.length">

      <branche :report="report" v-if="this.form.reference == 'branche'" />

      <team :report="report" v-if="this.form.reference == 'team'" :onOrder="onOrder" :orderRealizado="orderRealizado" :orderTicketMedio="orderTicketMedio" :orderTotalVendas="orderTotalVendas" :orderVendedor="orderVendedor" />
      
      <profile :report="report" v-if="this.form.reference == 'profile'" />

    </template>
    <template v-else>
      <div class="row">
        <div class="col-sm-12 text-center mt-10">
            <i class="material-icons icon-image-preview">new_releases</i>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 text-center mb-20">
          <h2>Nenhum registro encontrado.</h2>
        </div>
      </div>
    </template>

    <div class="row dont-print">
      <div class="col-md-12 text-center">
        <button type="button" @click="close()" class="btn btn-fill btn-danger">Voltar</button>
        <button type="button" @click="print()" class="btn btn-fill btn-info">Imprimir</button>
        <!-- <button type="button" @click="pdf()" class="btn btn-fill btn-warning">PDF</button> -->
        <!--button-- type="button" v-if="report.length" @click="excel()" class="btn btn-fill btn-success">Excel</!--button-->
      </div>
    </div>
  </div>
</template>
<script>

import GridProductionBranche from './GridProductionBranche';
import GridProductionTeam from './GridProductionTeam';
import GridProductionProfile from './GridProductionProfile';
// import api from '../../../services/api.service'

export default {
  components : {
    branche : GridProductionBranche,
    team : GridProductionTeam,
    profile : GridProductionProfile,
  },
  computed: {
    report(){
      return this.$store.state.reports.item;
    },
  },
  data() {
    return {
        orderRealizado: '•',
        orderTicketMedio: '•',
        orderTotalVendas: '•',
        orderVendedor: "•",
        title : 'Relatório - Ranking de Produção',
        sub_title : '',
        break_branch : null,
        break_team : null,
    };
  },
  methods: {
    close(){
      window.opener.focus();
      window.close();
    },
    async doOrder(orderItem, order) {
      var newOrder = "•";
      var self = this;
      switch(order) {
        case '•':
          console.log('Up');
          newOrder = "⇧";
          self.form.interval.orderBy = orderItem;
          self.form.interval.orderType = 'ASC'
          break;
        case '⇧':
          console.log('Down');
          newOrder = "⇩";
          self.form.interval.orderBy = orderItem;
          self.form.interval.orderType = 'DESC'
          break;
        case '⇩':
          console.log('Reset');
          newOrder = "•";
          self.form.interval.orderBy = '';
          self.form.interval.orderType = '';
          break;
      }

      await self.getData();

      return newOrder;
    },
    async getData(){
        let self = this;

        self.$root.$emit("onLoading");
        const response = self.$store.dispatch('reports/productionRating', self.form);

        response.then(function (_dataReports) {
            self.$root.$emit("onLoading");
        });

        response.catch(function () {
            self.$root.$emit("onLoading");
        });
    },
    print() {
      window.print();
    },
    // async pdf(){
    //   await api.post('/pdf', {});
    // },
    excel() {
      var nome = "RELATÓRIO DE PRODUÇÃO MENSAL";
      var htmlPlanilha =
        '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>' +
        nome +
        "</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><title>" +
        nome +
        "</title></head><body><table>" +
        document.getElementById("tabela").innerHTML +
        "</table>";
      var htmlBase64 = btoa(htmlPlanilha);
      var link = "data:application/vnd.ms-excel;base64," + htmlBase64;
      var hyperlink = document.createElement("a");
      hyperlink.download = "Relatório de Produção Mensal";
      hyperlink.href = link;
      hyperlink.style.display = "none";
      document.body.appendChild(hyperlink);
      hyperlink.click();
      document.body.removeChild(hyperlink);
    },
    async onOrder(itemOrder) {
      var self = this;
      switch (itemOrder) {
        case 'qtd_vendas':
          self.orderTotalVendas = '•';
          self.orderTicketMedio = '•';
          self.orderVendedor = '•';
          self.orderRealizado = await self.doOrder(itemOrder, self.orderRealizado);
          break;
        case 'total_vendas':
          self.orderRealizado = '•';
          self.orderTicketMedio = '•';
          self.orderVendedor = '•';
          self.orderTotalVendas = await self.doOrder(itemOrder, self.orderTotalVendas);
          break;
        case 'ticket_medio':
          self.orderRealizado = '•';
          self.orderTotalVendas = '•';
          self.orderVendedor = '•';
          self.orderTicketMedio = await self.doOrder(itemOrder, self.orderTicketMedio);
          break;
        case 'users.name':
          self.orderRealizado = '•';
          self.orderTotalVendas = '•';
          self.orderTicketMedio = '•';
          self.orderVendedor = await self.doOrder(itemOrder, self.orderVendedor);
          break;
        default:
          self.orderVendedor = '•';
          self.orderRealizado = '•';
          self.orderTotalVendas = '•';
          self.orderTicketMedio = '•';
      }
    }
  },
  mounted() {
    this.form = JSON.parse(this.$route.query.form);
    switch (this.form.reference) {
        case 'team':
                this.sub_title = 'POR EQUIPE DE VENDAS';
            break;
        case 'profile':
                this.sub_title = 'POR PERFIL';
            break;
        case 'branche':
                this.sub_title = 'POR LOJA';
            break;

        default:
            break;
    }
    
    this.getData();
  }
};
</script>
<style type="scss">
  @media print {
    .dont-print {
      display: none;
    }
  }

  .headerLine{
    background: #eaeaea;
    font-weight: bold;
  }
  .headerLineBlack{
    background:#000;
    color:#fff;
    font-weight: bold;
  }
</style>